import { useState } from 'react';
import { HUD } from '../hud/hud';
import { Ball } from './ball';
import { Board } from './board';
import { GameContext } from './score-context';
import { KeyWatcher } from '../key-watcher';
import { GameOverText } from '../game-over/game-over-text';

export function Game() {
  const [score, setScore] = useState(0);
  const [balls, setBalls] = useState(3);
  const [isDropped, setIsDropped] = useState(false);

  return (
    <GameContext.Provider value={{ score, setScore, balls, setBalls, isDropped, setIsDropped }}>
      {/* Ball */}
      {/* Key by balls remaining so we get a new one when the count changes */}
      <Ball key={balls} position={[-0.25, 9, 0]} />

      {/* Board */}
      <Board />

      {/* Game Over text */}
      <GameOverText />

      {/* HUD */}
      <HUD score={score} balls={balls} />

      {/* Key watcher */}
      <KeyWatcher />
    </GameContext.Provider>
  );
}
